import { EventData } from '../../tracking/tealium';
import { trackTealium } from './tracker';
import { isUsingTrackerModule } from '../../tracking/tealium-helper';
import { trackEvent as trackerTrackEvent } from '@tuic/tracking';

/**
 * Sends given data as an event, or queues the event until the first page view is sent.
 */
export const queueTrackEvent = (data: EventData): void => {
  if (isUsingTrackerModule()) {
    trackerTrackEvent(data);
    return;
  }

  if (window.__tuic_tracker_page_view_sent) {
    trackTealium(data, 'Event');
    return;
  }

  window.__tuic_tracker_event_queue = window.__tuic_tracker_event_queue ?? [];
  window.__tuic_tracker_event_queue.push(data);
};
